<template>
  <v-layout align-center relative key="register">
    
    <transition name="router-anim" mode="out-in">
      <v-flex px-4 v-if="success" key="1">
        <div class="display-1 font-weight-medium mb-3">
          {{ $t('sukces') }}
        </div>
        <div class="font-weight-light mb-4 c-lighter-1">
          {{ $t('zmiana-sukces') }}
        </div>
        <v-btn rounded large class="w-btn mb-3 t-empty" to="/">{{ $t('go-home') }}</v-btn>
      </v-flex>
      <v-flex px-4 v-else key="2">
        <div class="display-1 font-weight-medium mb-3">
          {{ $t('nowe-haslo') }}
        </div>

        <v-form
          ref="form"
          v-model="valid"
          class="poison"
        >

          <v-text-field
          v-model="password"
          :counter="8"
          :rules="passwordRules"
          :label="$t('haslo')"
          required
          type="password"></v-text-field>

          <v-text-field
          v-model="password2"
          :counter="8"
          :rules="password2Rules"
          :label="$t('haslo-powt')"
          required
          type="password"></v-text-field>
          
          <div class="text-center mt-3">
            <v-btn 
            :loading="saving"
            :disabled="saving" 
            @click="postForm"
            rounded large class="w-btn" color="primary">{{ $t('zmien-haslo') }}</v-btn>
          </div>

        </v-form>
        <v-snackbar
          v-model="snackbar"
          :multi-line="true"
          :color="snackbarColor"
        >
          {{ $t(snackbarText) }}
          <v-btn
            color="red"
            text
            @click="snackbar = false"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-flex>
    </transition>

  </v-layout>
</template>

<script>
  export default {
    data: () => ({
      valid: true,
      password: '',
      passwordRules: [
        v => !!v || 'Wypełnij hasło',
        v => (v && v.length >= 6) || 'Hasło musi mieć minimum 6 znaków'
      ],
      password2: '',
      password2Rules: [
        v => !!v || 'Wypełnij hasło',
        //v => (v && v.length >= 6) || 'Hasło musi mieć minimum 6 znaków'
      ],
      saving: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: "error",
      success: false
    }),
    computed: {
      token() {
        return this.$route.params.token
      }
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      postForm () {
        const formData = new URLSearchParams();
        formData.append('password', this.password);
        formData.append('password2', this.password2);
        formData.append('token', this.token);

        this.$store.dispatch('newpass', formData)
        .then(res => {
          this.saving = false;
          if (res == 'success') {
            this.success = true;
          } else {
            this.snackbarText = res;
            this.snackbar = true;
          }
        });
      }
    }
  }
</script>

<style>
</style>

